import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useFormikContext } from 'formik';

import Button from '@components/smartAdminUI/Button';
import FormikInputGroup from '@components/smartAdminUI/input/FormikInputGroup';

const OfficeLookup = ({ fields, validateFigField }) => {
  const officeNameField = useMemo(() => fields.find(field => field.FieldName.toUpperCase().includes('OFFICENAME')), [fields]);

  const { setFieldValue } = useFormikContext();

  const onOfficeClear = () => {
    if (fields) {
      fields.map(field => {
        setFieldValue(field.FieldName, '');
        return null;
      });
    }
  };

  return (
    <div className="form-row mb-3">
      <div className="col-md-10">
        <FormikInputGroup
          {...officeNameField}
          key={officeNameField?.RowID}
          validateFigField={validateFigField}
        />
      </div>
      <div className="col-auto">
        <div className="form-group mt-4 mb-4">
          <Button
            name="btnLookupOfficeClear"
            onClick={onOfficeClear}
            variant="primary"
            tooltipText="Clear Office"
          >
            <i className="far fa-times" aria-hidden="true" />
          </Button>
          <span data-toggle="modal" data-target="#officeLookupModal">
            <Button
              name="btnLookupOffice"
              variant="primary"
              tooltipText="Office Lookup"
            >
              <i className="fas fa-briefcase" aria-hidden="true" />
            </Button>
          </span>
        </div>
      </div>
    </div>
  );
};

OfficeLookup.propTypes = {
  fields: PropTypes.arrayOf(PropTypes.shape()),
  validateFigField: PropTypes.func.isRequired,
};

export default OfficeLookup;
